import { render, staticRenderFns } from "./SchoolYearControl.vue?vue&type=template&id=1371d725&scoped=true&"
import script from "./SchoolYearControl.vue?vue&type=script&lang=ts&"
export * from "./SchoolYearControl.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolYearControl.vue?vue&type=style&index=0&id=1371d725&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1371d725",
  null
  
)

export default component.exports